var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-overlay',{attrs:{"absolute":true,"opacity":1,"value":_vm.loading,"z-index":5}},[_vm._v("Loading...")]),_c('div',{staticClass:"main"},[_c('Header'),_vm._t("content"),_c('div',{staticClass:"spacer"}),_c('Footer')],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }